import React, { Component } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button'
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';


import TableLengthBySizeDMA from './table-lenght-by-size-dma/table-length-by-size-dma.component';
import TableLengthByTypeDMA from './table-length-by-type-dma/table-length-by-type-dma.component';

import './accordin-list-dma.style.css'

export class AccordinListDMA extends Component {
    render() {

        const dmaName = this.props.dmaName;
        const dataLengthByTypeDMA = this.props.dataLengthByTypeDMA.length;
        const dataLengthBySizeDMA = this.props.dataLengthBySizeDMA.size;
        return (
            <div>
                <Accordion  className="accordin-custom">
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                {dmaName}
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>

                                <div className="container-tab-table-total">
                                    <Tabs defaultActiveKey="length-by-type" id="uncontrolled-tab-example">
                                        <Tab eventKey="length-by-type" title="Length by type">
                                            <div className="wrapper-table-total-pipeline">
                                                <TableLengthByTypeDMA
                                                    dataLengthByType={dataLengthByTypeDMA}
                                                    dmaName = {dmaName}
                                                    ></TableLengthByTypeDMA>
                                            </div>
                                        </Tab>
                                        <Tab eventKey="length-by-size" title="Length by size">
                                            <div className="wrapper-table-total-pipeline">
                                                <TableLengthBySizeDMA
                                                    dataLengthBySize={dataLengthBySizeDMA}
                                                ></TableLengthBySizeDMA>
                                            </div>
                                        </Tab>
                                    </Tabs>
                                </div>


                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        )
    }
}

export default AccordinListDMA
